<template>
    <nav class="nav">
        <ul>
            <li v-for="nav in navItems">
                <router-link class="nav-item" :to="'/' + nav.path"> {{ nav.name }}</router-link>
            </li>
        </ul>
    </nav>
</template>
  
<script>
export default {
    name: "MainNav",
    props: {
        navItems: Array,
    },
};
</script>
  
<style lang="scss">
.nav {
    ul {
        display: flex;
        align-items: center;
        justify-content: center;

        li {
            @extend %BODY1;
            font-size: 16px;
        }

        .nav-item {
            transition: color .3s;

            &:hover {
                color: $main-color-hover;
            }
        }

        li:not(:first-child) {
            margin-left: 55px;
        }
    }

    a {
        font-weight: 500;
        color: #2c3e50;

        &.router-link-exact-active {
            color: $main-color-hover;
            pointer-events: none;
        }
    }
}

@media screen and (max-width: 800px) {
    .nav {
        ul {
            li:not(:first-child) {
                margin-left: 30px;
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .nav {
        ul {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;

            li:not(:first-child) {
                margin-left: 0;
                margin-top: 15px;
            }
        }
    }
}
</style>
  